import { IconProps } from "./types";

const ArrowDownIcon: React.FC<IconProps> = ({ className }) => {
  return <img className={className} src="../../assets/images/arrow.svg" alt="" />;
};

export default ArrowDownIcon;
